import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.16675 8.33359H7.49175V12.5003C7.49175 12.9586 7.86675 13.3336 8.32508 13.3336H11.6584C12.1167 13.3336 12.4917 12.9586 12.4917 12.5003V8.33359H13.8167C14.5584 8.33359 14.9334 7.43359 14.4084 6.90859L10.5834 3.08359C10.2584 2.75859 9.73341 2.75859 9.40841 3.08359L5.58341 6.90859C5.05841 7.43359 5.42508 8.33359 6.16675 8.33359ZM4.16675 15.8336C4.16675 16.2919 4.54175 16.6669 5.00008 16.6669H15.0001C15.4584 16.6669 15.8334 16.2919 15.8334 15.8336C15.8334 15.3753 15.4584 15.0003 15.0001 15.0003H5.00008C4.54175 15.0003 4.16675 15.3753 4.16675 15.8336Z" })
});
export default SvgUpload;
